import s from "./ConfirmModal.module.css";
import {Dispatch, SetStateAction} from "react";
import CustomModal from "../../../../components/ui/CustomModal/CustomModal";
import TransparentButton from "../../../../components/ui/TransparentButton/TransparentButton";
import MyBtn from "../../../../components/ui/MyBtn/MyBtn";
import {useAppDispatch, useAppSelector} from "../../../../hooks/redux";
import {deleteTemplateThunk} from "../../../../store/reducers/ActionCreators";
import trashIcon from "../../../../assets/img/personalAccount/trash_notify.svg"

interface ConfirmModalProps {
  setShowModal: Dispatch<SetStateAction<boolean | null>>,
  showModal: boolean | null,
  TemplateForDelete: {
    id: number,
    name: string
  }
  getStatusOfDeletedTemplate?: (res: any) => void
}

export const ConfirmModal = ({setShowModal, showModal, TemplateForDelete, getStatusOfDeletedTemplate}: ConfirmModalProps) => {

  const token = useAppSelector(state => state.userReducer.userToken)
  const accountId = useAppSelector(state => state.userReducer.chosenAccountTypeId)
  const dispatch = useAppDispatch()

  return (
    <CustomModal type={'error'} setIsModalOpen={setShowModal} isModalOpen={showModal} children={
      <div className={s.modalContent}>

        <img src={trashIcon} alt="" className={s.icon}/>

        <h3 className={s.modalTitle}>Are you sure?</h3>
        <h4 className={s.modalSubtitle}>Your template <b>{TemplateForDelete.name}</b> will be deleted.</h4>

        <div className={s.buttonsWrapper}>
          <div className={s.buttonBlock}>
            <TransparentButton buttonType={'error'} isPersonalAccountBtn medium onClick={() => {
              dispatch(deleteTemplateThunk(token, TemplateForDelete.id, accountId))
                  .then((res) => {
                    if (getStatusOfDeletedTemplate) {
                      getStatusOfDeletedTemplate(res)
                    }
                  })
                  .catch((e) => {
                    if (getStatusOfDeletedTemplate) {
                      getStatusOfDeletedTemplate(e)
                    }
                  })
              setShowModal(false)
            }} title={'Delete'}/>
          </div>
          <div className={s.buttonBlock}>
            <MyBtn buttonType={'error'} isPersonalAccountBtn medium title={'Cancel'} onClick={() => {
              setShowModal(false)
            }}/>
          </div>
        </div>

      </div>
    }/>
  )
}

